function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#99a1a6",
  strokeMiterlimit: 10,
  d: "M32 11h5a1 1 0 0 0 1-1V3.263a.997.997 0 0 0-.925-.997C35.484 2.153 32.376 2 30.141 2 24 2 20 5.68 20 12.368V19h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7v19a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V28h7.222a1 1 0 0 0 .994-.89l.778-7A1 1 0 0 0 37 19h-8v-5a3 3 0 0 1 3-3z",
  fontFamily: "none",
  fontSize: "none",
  fontWeight: "none",
  style: {
    mixBlendMode: "normal"
  },
  textAnchor: "none",
  transform: "scale(5.12)"
}));
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "9de711b4681422e7ae723ea64b630165.svg";